/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Minus = ["svg", defaultAttributes, [["path", { d: "M5 12h14" }]]];

export { Minus as default };
//# sourceMappingURL=minus.js.map
